export default {
	methods: {
		handleTagsClose() {
			this.tagsModalOn = false
			this.tagInQuestion = false
		}
	}
}